import type {
  BetslipActions,
  BetslipStore,
  SliceCreator,
} from "@/features/betslip/stores/types";

export const initialOverlayState: Pick<BetslipStore, "overlay"> = {
  overlay: { type: "none" },
};

type OverlayActions = Pick<BetslipActions, "setOverlay">;

export const overlaySlice: SliceCreator<
  typeof initialOverlayState & OverlayActions
> = (set) => ({
  ...initialOverlayState,

  setOverlay: (overlay) => {
    set({ overlay });
  },
});
